import { Status } from 'src/models/AuthContextModels';
import { ForecastPlanningCycleIds, MasterScenarios, PlanningCycleEntity, PlanningCycleSnapshot } from 'src/models/PlanningCycleModel';

/**
 * State interface definition for the planning cycle feature.
 */
export interface PlanningCycleState {
  scenarios: MasterScenarios[];

  planningCyclesLoadingStatus: Status;
  planningCycles: PlanningCycleEntity[];

  forecastPlanningCyclesStatus: Status;
  forecastPlanningCycles: ForecastPlanningCycleIds[];

  planningCycleSnapshotsStatus: Status;
  planningCycleSnapshots: PlanningCycleSnapshot[];

  updateStatus: 'idle' | 'loading' | 'succeeded' | 'failed';
  updateError: string | null;
}

/**
 * Initial state for the planning cycle slice.
 */
export const initialState: PlanningCycleState = {
  scenarios: [],

  planningCyclesLoadingStatus: Status.NotInitiated,
  planningCycles: [],

  forecastPlanningCyclesStatus: Status.NotInitiated,
  forecastPlanningCycles: [],

  planningCycleSnapshotsStatus: Status.NotInitiated,
  planningCycleSnapshots: [],

  updateStatus: 'idle',
  updateError: null
};
